module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderEdit"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "pageNav"
  }, [(_vm.editType != 'hotline' && _vm.fromPage != 'hotline') ? _c('i', {
    staticClass: "goBack el-icon-arrow-left",
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editType != 'hotline' && _vm.fromPage != 'hotline') ? _c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.Language(_vm.editType == 'examine' ? '工单审批' : _vm.editType == 'edit' ? '工单跟进' : _vm.editType == 'add' ? '新建工单' : _vm.editType == 'info' ? '查看工单' : _vm.editType == 'supervise' ? '督办工单' : '工单回访')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.editType == 'edit' || _vm.editType == 'hotline') && _vm.sFormInfo.status != 8) ? _c('div', {
    staticClass: "operateList"
  }, _vm._l((_vm.buttonList), function(item, index) {
    return _c('el-button', {
      key: index,
      attrs: {
        "type": "primary",
        "size": "mini",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.operateFn(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.editType == 'supervise') ? _c('div', {
    staticClass: "operateList"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.operateFn('打回')
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('打回')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.operateFn('转派')
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('转派')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.operateFn('关闭')
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('关闭')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "contentBox pt-15"
  }, [_c('div', {
    staticClass: "content-form"
  }, [_c('div', {
    staticClass: "orderForm"
  }, [(_vm.dialogShow) ? _c('OrderForm', {
    ref: "sFormInfo",
    attrs: {
      "dialogShow": _vm.dialogShow,
      "sFormInfo": _vm.sFormInfo,
      "editType": _vm.editType,
      "examineId": _vm.examineId,
      "returnId": _vm.returnId,
      "hotlineObj": _vm.hotlineObj
    },
    on: {
      "saveFn": _vm.saveFn
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-tabs', {
    staticClass: "notRight",
    model: {
      value: (_vm.tabsActive),
      callback: function($$v) {
        _vm.tabsActive = $$v
      },
      expression: "tabsActive"
    }
  }, [(_vm.editType != 'hotline') ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.Language('跟进记录'),
      "name": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "padding": "10px 20px",
      "overflow-y": "auto"
    }
  }, [(!_vm.followRecord.length) ? _c('el-empty', {
    attrs: {
      "description": _vm.Language('暂无记录')
    }
  }, [_c('i', {
    staticClass: "iconfont icongongdan font-36",
    staticStyle: {
      "color": "#909399"
    },
    attrs: {
      "slot": "image"
    },
    slot: "image"
  })]) : _c('el-timeline', _vm._l((_vm.followRecord), function(item, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "type": "primary",
        "timestamp": item.createDate,
        "placement": "top"
      }
    }, [_c('el-card', [_c('div', {
      staticClass: "changeItem"
    }, [_c('p', {
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.Language('处理人')) + "：" + _vm._s(item.userId ? _vm.optionList['userList'].filter(function (uItem) {
      return uItem.userId == item.userId
    })[0].agentName : '') + "\n                      ")]), _vm._v(" "), (item.isJson) ? _c('div', {
      staticClass: "changeContent"
    }, _vm._l((item.content), function(cont, cIndex) {
      return _c('p', {
        key: cIndex,
        staticStyle: {
          "padding": "5px 10px"
        }
      }, [_vm._v(_vm._s(cIndex) + "：" + _vm._s(cont))])
    }), 0) : _c('div', {
      staticClass: "changeContent"
    }, [_c('p', {
      staticStyle: {
        "padding": "5px 10px"
      }
    }, [_vm._v(_vm._s(item.content))])])])])], 1)
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.editType != 'hotline') ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.Language('催单记录'),
      "name": "2"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [(!_vm.reminderRecord.length) ? _c('el-empty', {
    attrs: {
      "description": _vm.Language('暂无记录')
    }
  }, [_c('i', {
    staticClass: "iconfont icongongdan font-36",
    staticStyle: {
      "color": "#909399"
    },
    attrs: {
      "slot": "image"
    },
    slot: "image"
  })]) : _c('el-timeline', _vm._l((_vm.reminderRecord), function(item, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "type": "primary",
        "timestamp": item.createDate,
        "placement": "top"
      }
    }, [_c('el-card', [_c('div', {
      staticClass: "changeItem"
    }, [_c('p', {
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.Language('催单人')) + "：" + _vm._s(item.createOper ? _vm.optionList['userList'].filter(function (uItem) {
      return uItem.userId == item.createOper
    })[0].agentName : '') + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "changeContent"
    }, [_c('p', {
      staticStyle: {
        "padding": "5px 10px"
      }
    }, [_vm._v(_vm._s(_vm.Language('催单内容')) + "：" + _vm._s(item.reason))])])])])], 1)
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.editType != 'hotline') ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.Language('回访记录'),
      "name": "3"
    }
  }, [_c('el-table', {
    staticClass: "default-button-box",
    attrs: {
      "data": _vm.returnRecord,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "satType",
      "label": _vm.Language('评价方式')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.Language(scope.row.satType == '1' ? '短信' : scope.row.satType == '2' ? '邮件' : scope.row.satType == '3' ? '电话' : '')))])]
      }
    }], null, false, 1605071746)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isOpenSolved",
      "label": _vm.Language('开启解决')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.Language(scope.row.isOpenSolved == 1 ? '是' : '否')))]
      }
    }], null, false, 3942311034)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isSolved",
      "label": _vm.Language('是否解决')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.Language(scope.row.isSolved == 1 ? '是' : '否')))]
      }
    }], null, false, 3405662414)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "satisfied",
      "label": _vm.Language('是否满意')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.Language(scope.row.satisfied == 1 ? '是' : '否')))]
      }
    }], null, false, 940810561)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.Language('评价名')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "detContent",
      "label": _vm.Language('评价明细'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": _vm.Language('评价描述'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visitOper",
      "label": _vm.Language('回访人')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.visitOper ? _vm.optionList['userList'].filter(function (uItem) {
          return uItem.userId == scope.row.visitOper
        })[0].agentName : '') + "\n                ")]
      }
    }], null, false, 2384060984)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visitDate",
      "label": _vm.Language('回访时间'),
      "width": "160px"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editType != 'hotline') ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.Language('延期记录'),
      "name": "4"
    }
  }, [_c('el-table', {
    staticClass: "default-button-box",
    attrs: {
      "data": _vm.delayRecord,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "reason",
      "label": _vm.Language('延期原因'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "duration",
      "label": _vm.Language('延期时长(h)')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkRes",
      "label": _vm.Language('审批结果')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.Language(scope.row.checkRes == 0 ? '待审批' : scope.row.checkRes == 1 ? '通过' : scope.row.checkRes == 2 ? '未通过' : scope.row.checkRes == 3 ? '取消' : '')) + "\n                ")]
      }
    }], null, false, 1552527271)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createOper",
      "label": _vm.Language('申请人')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatColumn('createOper', scope.row)))])]
      }
    }], null, false, 511591804)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": _vm.Language('申请时间'),
      "width": "160px"
    }
  }), _vm._v(" "), (_vm.editType != 'info' && _vm.editType != 'return') ? _c('el-table-column', {
    attrs: {
      "label": _vm.Language('操作'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "enterable": false,
            "content": _vm.Language('取消'),
            "placement": "top"
          }
        }, [(scope.row.checkRes == 0) ? _c('i', {
          staticClass: "iconfont iconny-023quxiao table-icon-btn",
          on: {
            "click": function($event) {
              return _vm.extensionApplyCancelFn(scope.row)
            }
          }
        }) : _vm._e()])]
      }
    }], null, false, 160543284)
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.Language('历史工单'),
      "name": "5"
    }
  }, [_c('el-table', {
    staticClass: "default-button-box",
    attrs: {
      "data": _vm.historyRecord,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": _vm.Language('标题'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderTypeCode",
      "label": _vm.Language('工单类型'),
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatColumn('orderTypeCode', scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "originName",
      "label": _vm.Language('渠道名称'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": _vm.Language('工单状态'),
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatColumn('status', scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "priorityCode",
      "label": _vm.Language('优先级'),
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatColumn('priorityCode', scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": _vm.Language('受理部门'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": _vm.Language('受理人'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": _vm.Language('创建时间'),
      "width": "160px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.Language('操作'),
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "enterable": false,
            "content": _vm.Language('跟进'),
            "placement": "top"
          }
        }, [(scope.row.status != 8) ? _c('el-button', {
          staticStyle: {
            "padding": "0",
            "margin": "0"
          },
          attrs: {
            "type": "text",
            "icon": "iconfont icongongdanguanli1 table-icon-btn"
          },
          on: {
            "click": function($event) {
              return _vm.onEditOrder(scope.row, 1)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "enterable": false,
            "content": _vm.Language('查看'),
            "placement": "top"
          }
        }, [_c('el-button', {
          staticStyle: {
            "padding": "0",
            "margin": "0"
          },
          attrs: {
            "type": "text",
            "icon": "iconfont iconchakan1 table-icon-btn"
          },
          on: {
            "click": function($event) {
              return _vm.onEditOrder(scope.row, 2)
            }
          }
        })], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, [_c('div', {
    staticClass: "customerInfo"
  }, [_c('p', {
    staticClass: "infoTitle"
  }, [_vm._v("\n            " + _vm._s(_vm.Language('客户信息')) + "\n            "), (_vm.editType != 'examine' && _vm.editType != 'info') ? _c('el-button', {
    staticClass: "padding5 ml-10",
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveFn(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('保存')))]) : _vm._e(), _vm._v(" "), (_vm.editType != 'examine' && _vm.editType != 'info' && _vm.customerInfo.id) ? _c('el-button', {
    staticClass: "padding5 ml-10",
    attrs: {
      "type": "info",
      "plain": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleResetFn(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('重置')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "infoBox"
  }, [(_vm.dialogShow) ? _c('FormData', {
    ref: "orderCusInfo",
    attrs: {
      "formColumnList": _vm.cusColumns,
      "dialogShow": _vm.dialogShow,
      "sFormInfo": _vm.customerInfo,
      "orderEdit": true,
      "editType": _vm.editType,
      "hotlineObj": _vm.hotlineObj
    },
    on: {
      "saveFn": _vm.saveCustomerInfo,
      "changeCusInfo": _vm.changeCusInfo
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "companyInfo"
  }, [_c('p', {
    staticClass: "infoTitle"
  }, [_vm._v("\n            " + _vm._s(_vm.Language('公司信息')) + "\n            "), (_vm.editType != 'examine' && _vm.editType != 'info') ? _c('el-button', {
    staticClass: "padding5 ml-10",
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveFn(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('保存')))]) : _vm._e(), _vm._v(" "), (_vm.editType != 'examine' && _vm.editType != 'info' && _vm.customerPanyInfo.id) ? _c('el-button', {
    staticClass: "padding5 ml-10",
    attrs: {
      "type": "info",
      "plain": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleResetFn(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('重置')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "infoBox"
  }, [(_vm.dialogShow) ? _c('FormData', {
    ref: "orderCusPanyInfo",
    attrs: {
      "formColumnList": _vm.cusPanyColumns,
      "dialogShow": _vm.dialogShow,
      "sFormInfo": _vm.customerPanyInfo,
      "orderEdit": true,
      "editType": _vm.editType
    },
    on: {
      "saveFn": _vm.saveCustomerPanyInfo,
      "changeCusCompanyInfo": _vm.changeCusCompanyInfo
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "addOperator center-dialog Operator-add new-dialog-box",
      "title": _vm.Language(_vm.operateTitle),
      "width": "40%",
      "visible": _vm.operateVisible,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.operateVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "operateForm",
    staticClass: "all-form formStyle",
    staticStyle: {
      "padding": "10px 20px"
    },
    attrs: {
      "model": _vm.operateForm,
      "rules": _vm.rules,
      "label-width": "80px",
      "size": "small"
    }
  }, [(_vm.operateVal == 1 || _vm.operateVal == 10) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('分配人员'),
      "prop": "remark"
    }
  }, [_c('DepartPersonSelect', {
    ref: "DepartPerson"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.operateVal == 5) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('延期原因'),
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": _vm.Language('请输入延期原因'),
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.operateForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.operateForm, "reason", $$v)
      },
      expression: "operateForm.reason"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.Language('延期时长'),
      "prop": "duration"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "controls-position": "right",
      "step": 0.1,
      "min": 0,
      "step-strictly": ""
    },
    model: {
      value: (_vm.operateForm.duration),
      callback: function($$v) {
        _vm.$set(_vm.operateForm, "duration", $$v)
      },
      expression: "operateForm.duration"
    }
  }), _vm._v("  小时\n        ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.operateVal == 6 || _vm.operateVal == 7 || _vm.operateVal == 8 || _vm.operateVal == 9) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.Language(_vm.operateVal == 6 ? '撤回原因' : _vm.operateVal == 7 ? '催单原因' : _vm.operateVal == 8 ? '驳回原因' : '打回原因'),
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": _vm.Language('请输入') + _vm.Language(_vm.operateVal == 6 ? '撤回原因' : _vm.operateVal == 7 ? '催单原因' : _vm.operateVal == 8 ? '驳回原因' : '打回原因'),
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.operateForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.operateForm, "reason", $$v)
      },
      expression: "operateForm.reason"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "diglog-bom-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSubmitFn
    }
  }, [_vm._v(_vm._s(_vm.Language('提 交')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.operateVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-819e7c5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/OrderEdit.vue
// module id = 1339
// module chunks = 5